// extracted by mini-css-extract-plugin
module.exports = {"playButton":"z-GEP-","svg":"_1XN8b1","circle":"_1n8-io","triangle":"Jxp5Is","playbackAction":"_1xcsof","playbackLabel":"_2LJJ7z"};